import React, {useState, useEffect} from 'react'
import {Table, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirestore} from 'react-redux-firebase';
import {useDispatch} from 'react-redux';
import {env} from '../../constants/Environment';
import * as RouterActions from '../../actions/RouterActions';

export function Channelselect(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const [channels, setChannels] = useState([]);

    useEffect(() => {
        (async () => {
            const snapshot = await firestore.collection('environments/' + env + '/canvas').get();

            const c = [];
            snapshot.forEach(doc => {
                c.push({
                    id: doc.id,
                    ...doc.data()
                });
            });

            setChannels(c);
        })();
    }, [channels.length === 0]);

    return (
        <div style={{
            padding: '1em'
        }}>
            Bitte wählen Sie einen Programmtyp:
            {
                (channels).map((channel) => (
                    <a style={{
                        padding: '1em',
                        cursor: 'pointer'
                    }} key={channel.id} onClick={(e) => {
                        props.onChannelSelect(channel.id);
                    }}>{channel.name}</a>
                ))
            }
        </div>
    );
}